import React from "react";

import moment from 'moment';

import { withStyles } from '@mui/styles';
import { Button, Tooltip } from '@mui/material';

import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowRightOutlined from "@mui/icons-material/ArrowRightOutlined";
import CheckIcon from '@mui/icons-material/Check';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import Settings from "@mui/icons-material/Settings";

import ArrowTooltipComponent from "../../common/ArrowTooltip";

import CommonStyles from "../../common/CommonStyles";
import CopyBtn from "../../common/CopyBtn";
import LoaderNew from "../../common/LoaderNew";
import ComponentWrapper from "../../common/ComponentWrapper";
import CardAnalitics from "../../common/CardAnalitics";

import {
  nodesParams,
  boxParamsTable,
  prdcParamsTable,
  getUrlParameter,
  removeUrlParameter,
  trplsParamsTableMatching,
} from '../../utils';

import OnboardingDialog from "./components/AiOnboarding";
import AnnounceBlock from "../../common/AnnounceBlock";

const styles = {
  fontColor: {
    color: '#1B1920',
  },
  tooltip: {
    zIndex: 1000,
    margin: '0',
    background: '#4E4C4C',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    borderRadius: 0,
    padding: '10px 15px',
  },
  iconLock: {
    marginLeft: '4px',
    fontSize: '14px',
    color: '#AFAECF',
  },
  insetShadowInput: {
    backgroundColor: '#F1F1F6',
    boxShadow: 'inset 0px 1px 1px #D6D6D6',
    width: '300px',
    fontSize: 14,
    height: '30px',
    border: 'none',
    '&:focus': {
      outline: '1px solid #70b8ff'
    },
  },
  okBtn: {
    height: '30px',
    padding: '5px 30px',
    minWidth: '90px',
    backgroundColor: '#222029',
    color: 'white',
    opacity: '0.8',
    '&:hover': {
      opacity: '1.0',
      backgroundColor: '#222029',
    },
  },
  descriptionFont: {
    fontSize: 14,
    lineHeight: 1.6,
  },
  popup: {
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '30px',
    maxWigth: '720px',
    borderRadius: '10px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
  },
  popupContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(5px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  linkToBlock: {
    color: '#347CFF',
    cursor: 'pointer',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    borderBottom: '1px dashed #AFAECF',
    '&:hover': {
      outline: '1px solid #347CFF',
    },
  },
  linkToHideOpenBlock: {
    color: '#4c4c4c',
    cursor: 'pointer',
    fontWeight: 550,
    whiteSpace: 'nowrap',
    borderBottom: '1px dashed #AFAECF',
    '&:hover': {
    },
  },
  dashboardToBlock: {
    color: '#347CFF',
    cursor: 'pointer',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  h2Title: {
    fontSize: 18,
    fontWeight: 550,
  },
  gradientWhiteBtn: {
    ...CommonStyles.gradientBlackBtn,
    marginTop: 0,
    marginLeft: 0,
    backgroundImage: 'linear-gradient(to right, #ebf0f9 0%, #CFDEF3 51%, #eee0fc 100%)',
    color: '#1B1920',
    '&:hover': {
      backgroundPosition: 'center right',
      color: '#1B1920',
    }
  },
  gradientOrangeBtn: {
    ...CommonStyles.gradientBlackBtn,
    marginTop: 0,
    marginLeft: 0,
    backgroundImage: 'linear-gradient(to right, #FF8008 0%, #FFC837 51%, #FF8008 100%)',
    color: '#ffff',
    '&:hover': {
      backgroundPosition: 'center right',
      color: '#ffff',
    }
  },
...CommonStyles,
};

class DashboardAiPage extends ComponentWrapper {
  state = {
    allInstructionOpened: false,
    showConfirmGmailConnected: false,
    redirectInstructionOpened: false,
    loadboardInstructionOpened: false,
    userTestEmailSent: false,
    loadingSendBtn: false,
    userCompanyEmail: '',
    verificationEmail: '',
    emailSentMesShow: true,
    openOnboarding: false,
    driversWithZips: 0,
    totalDrivers: 0,
    wasHidden: false,
    diversData: null,
    timeout: null,
  };

  componentDidMount = () => {
    const { userRegistrationEmailAddress, parsingStarted } = this.props;

    const userInstructionKey = userRegistrationEmailAddress + '.instruction';

    const cChannelId = getUrlParameter('gmail_auth_sid');
    if (cChannelId) this.setState({ showConfirmGmailConnected: 'true' });

    this.updateDriversData();

    if (localStorage.getItem(userInstructionKey) === 'true' || !parsingStarted) this.setState({ allInstructionOpened: true });

    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  };

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  };

  handleVisibilityChange = () => {
    if (document.hidden) {
      this.setState({ wasHidden: true });
    } else if (this.state.wasHidden) {
      this.updateDriversData();
      this.props.getUserAiDataUpdate(true);
      this.setState({ wasHidden: false });
    }
  };

  onEmailProviderClick = (provider) => {
    window.open(`http://${window.location.host}/tutorial#${provider}`, "_blank");
  };

  emailToCopy = () => {
    return (
      <div
        className={`${this.props.classes.alignCenter}`}
        style={{ display: 'inline-flex', padding: '2px 5px', background: '#fff' }}
      >
        <span style={{ color: '#347CFF' }}>{this.props.milkyUserEmail}</span>
        <CopyBtn
          text={this.props.milkyUserEmail}
          copyIconStyles={{
            margin: '0 0 0 5px',
            fontSize: '14px',
            color: '#347CFF'
          }}
        />
      </div>
    )
  };

  convertToHTMLWithLinks(email) {
    let paragraphs = email.split('\n\n');

    paragraphs = paragraphs.map(paragraph => {
        let lines = paragraph.split('\n');
        let htmlLines = lines.map(line => {
            if (line.trim().startsWith('http')) {
                return '<a href="' + line.trim() + '" target="_blank">' + line.trim() + '</a>';
            } else {
                return line.trim();
            }
        });
        return htmlLines.join('<br>');
    });

    return paragraphs.join('<br><br>');
  };

  isHTMLString(str) {
    return /<[a-z][\s\S]*>/i.test(str);
  };

  addTargetBlankToLinks(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
  
    const links = doc.querySelectorAll('a');
  
    links.forEach(link => {
      link.setAttribute('target', '_blank');
    });
  
    return doc.documentElement.outerHTML;
  };

  instructionStateToLS = (isOpened) => {
    const { userRegistrationEmailAddress } = this.props;

    const userInstructionKey = userRegistrationEmailAddress + '.instruction';
    localStorage.setItem(userInstructionKey, isOpened);
  };

  updateDriversData = () => {
    const { setup } = this.props;

    const reqData = {
      nesting: 3,
      api_key: setup.id,
      filter: {
        limit: 3000,
        ancestor: 23978904,
      },
    };

    reqData.render = {
      trpl:{
        type:"o",
        params: trplsParamsTableMatching,
      },
      node:{
        type:"a",
        params: nodesParams,
      },
      prdc:{
        type:"a",
        params: prdcParamsTable,
      },
      box:{
        type:"a",
        params: boxParamsTable,
      }
    };

    reqData.show_pids = [1719];

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok') {
          const driversWithZips = res.trpls && Object.keys(res.trpls).length;
          const driversWithoutZips = res.query && res.query.length ? res.query.length - driversWithZips : 0;
          const totalDrivers = res.query ? res.query.length : 0;

          this.setState({ diversData: res, driversWithoutZips, totalDrivers, driversWithZips });
        }
      },
    });
  };

  sendUserTestEmail = () => {
    const { userCompanyEmail } = this.state;
    const { node } = this.props;

    if (!node) return;

    this.setState({ loadingSendBtn: true, userTestEmailSent: false }, () => { //emailSentMesShow: false, 
      this.postWithData({
        url: `/rest/run_macros`,
        data: {
          pid: 1839,
          eid: node,
          args: { email: userCompanyEmail.trim() },
        },
        cb: (res) => {
          if (res && res._status === 'ok') {
            this.setState({ userTestEmailSent: true });
            setTimeout(() => {
              this.setState({ userTestEmailSent : false });
            }, 15000);
          }
          this.setState({ loadingSendBtn: false });
        }
      });
    });
  };

  onCloseOnboarding = () => {
    this.props.updateJelsSimple();
    this.setState({ openOnboarding: false });
  };

  redirectSetupTestForm = () => {
    const { classes } = this.props;
    const { userCompanyEmail, userTestEmailSent, userEmailInvalid, loadingSendBtn } = this.state;
    return (
      <div className={`${classes.descriptionFont}`} style={{ margin: '0 10px 20px', backgroundColor: '#ffff' }}>
        <span><strong>Enter Your Work Email Address:</strong> In the form below, input the email address from which you've set&nbsp;up the&nbsp;redirection:</span><br></br>
        <div className={`${classes.alignCenter} ${classes.mt10}`}>
          <input
            value={userCompanyEmail}
            placeholder="email@example.com"
            className={`${classes.insetShadowInput}`}
            onChange={(e) => this.setState({ userCompanyEmail: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && userCompanyEmail && userCompanyEmail.length) this.sendUserTestEmail();
            }}
          />
          <div className={`${classes.ml10}`}>
            <Button
              disabled={!userCompanyEmail || userEmailInvalid}
              disableElevation
              size="small"
              variant="contained"
              className={`${classes.actionBtn} ${classes.thirdSmallBtn}`}
              onClick={(e) => {
                e.preventDefault();
                this.sendUserTestEmail();
              }}>
              {loadingSendBtn ? <LoaderNew color='white'/> : 'Send'}
            </Button>
          </div>
          {userTestEmailSent ?
            <div className={classes.alignCenter}>
              {/* {emailSentMesShow ?
                <div className={classes.alignCenter}>
                  <LoaderNew className={`${classes.ml15}`}/>
                  <span style={{ fontSize: 12 }} className={`${classes.mr10} ${classes.ml10} ${classes.nowrap}`}>Confirmation...</span>
                </div>
                {/* } */}
            </div>
          : null}
        </div>
        {userEmailInvalid ?
          <div className={classes.mt10}>
            <span style={{ color: '#D91920' }}>Please, type the email address you used for the redirect setup.</span>
          </div>
        : null}
      </div>
    )
  };

  revokeGmailRedirect = (cb) => {
    const { node } = this.props;
    if (!node) this.notify('error', `There is an issue an running Gmail 'Revoke access'. Contact the support team.`);
    else {
      this.get({
        url: `/google/oauth2/revoke?id=${node}`,
        cb: () => {
          this.props.getUserData();
          cb();
        }
      });
    }
  };

  arrowRight = <ArrowRightOutlined style={{ color: '#878787', fontSize: '16px' }}/>
  settingsIcon = <Settings style={{ color: '#878787', fontSize: '16px' }}/>

  runBackgroundCheckOfIncomingEmails = () => {
    const { getUserAiDataUpdate, parsingStarted } = this.props;
    const { timeout, openOnboarding } = this.state;
    
    clearTimeout(timeout);
    if (openOnboarding && parsingStarted) {
      const newTimeout = setTimeout(() => {
        if (!document.hidden) getUserAiDataUpdate(true);
        this.runBackgroundCheckOfIncomingEmails();
      }, 10000);

      this.setState({ timeout: newTimeout });
    }
  };

  timeAgo = (timestamp) => {
    const now = new Date().getTime();
    const secondsPast = Math.floor((now - timestamp) / 1000);

    if (secondsPast < 5) return "just now";
    if (secondsPast < 60) return `${secondsPast} seconds ago`;
    if (secondsPast < 120) return "a minute ago";
    if (secondsPast < 3600) return `${Math.floor(secondsPast / 60)} minutes ago`;
    if (secondsPast < 7200) {
      const minutes = Math.floor((secondsPast % 3600) / 60);
      return minutes > 0 ? `1 hour ${minutes} minutes ago` : "an hour ago";
  }
  if (secondsPast < 86400) {
      const hours = Math.floor(secondsPast / 3600);
      const minutes = Math.floor((secondsPast % 3600) / 60);
      return minutes > 0 ? `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minutes ago` : `${hours} hour ago`;
  }
    if (secondsPast < 172800) return "yesterday";
    return `${moment(timestamp).format('HH:mm, MMM DD, YYYY')}`;
    // if (secondsPast < 604800) return `${Math.floor(secondsPast / 86400)} days ago`;
    // if (secondsPast < 2592000) return `${Math.floor(secondsPast / 604800)} weeks ago`;
    // if (secondsPast < 31536000) return `${Math.floor(secondsPast / 2592000)} months ago`;
    // return `${Math.floor(secondsPast / 31536000)} years ago`;
  };

  render() {
    const {
      classes,
      lastMsgTime,
      gmailECMEmail,
      milkyUserEmail,
      parsingStarted,
      showUserConfirm,
      runGmailAuthBtn,
      verificationEmail,
      sylectusAuthEmail,
      getUserAiDataUpdate,
      gmailECMEmailAuthorized,
      verificationEmailCreationTime,
      sylectusAuthEmailCreationTime,
    } = this.props;

    const {
      diversData,
      totalDrivers,
      driversWithZips,
      loadingSendBtn,
      openOnboarding,
      //emailSentMesShow,
      userCompanyEmail,
      userTestEmailSent,
      driversWithoutZips,
      allInstructionOpened,
      showConfirmGmailConnected,
      redirectInstructionOpened,
      loadboardInstructionOpened,
    } = this.state;

    let convertedVerificationEmail;
    if (verificationEmail) {
      if (this.isHTMLString(verificationEmail) === false) convertedVerificationEmail = this.convertToHTMLWithLinks(verificationEmail);
      else convertedVerificationEmail = this.addTargetBlankToLinks(verificationEmail);
    }

    let convertedSylectusAuthEmail;
    if (sylectusAuthEmail) {
      if (this.isHTMLString(verificationEmail) === false) convertedSylectusAuthEmail = this.convertToHTMLWithLinks(sylectusAuthEmail);
      else convertedSylectusAuthEmail = this.addTargetBlankToLinks(sylectusAuthEmail);
    }

    const userEmailInvalid = userCompanyEmail && milkyUserEmail && (userCompanyEmail.trim() === milkyUserEmail.trim());

    const milkyGeneratedEmail =
    <div className={`${classes.ml10} ${classes.alignCenter}`} style={{ padding: '3px 5px', background: '#fff', width: 'fit-content' }}>
      <span style={{ color: '#347CFF' }}>{milkyUserEmail}</span>
      <CopyBtn
        text={milkyUserEmail}
        copyIconStyles={{
          marginLeft: '5px',
          fontSize: '14px',
          color: '#347CFF'
        }}
      />
      <ArrowTooltipComponent title="It's our auto-generated email, completely safe and secure, and will be used only as an intermediary between your inbox with loads and the Milkyweb matching system">
        <LockRoundedIcon className={classes.iconLock}/>
      </ArrowTooltipComponent>
    </div>;

    return (
      <div>
        <div className={`${classes.spaceBetween} ${classes.m20} ${classes.mb30}`}>
          <div>
            <AnnounceBlock>
              <div
                style={{
                  padding: '8px 20px 12px',
                  borderRadius: '0.5rem',
                  backdropFilter: 'blur(19px)',
                  backgroundColor: 'rgb(255 255 255 / 69%)',
                }}
              >
                <span style={{ fontSize: 18 }}>💫</span>&nbsp;<strong style={{ lineHeight: 3 }}>New: Awarded Load Tracking</strong><br></br>
                Mark which loads you've won — and help us train your personalized bid prediction model.<br></br>
                <div className={classes.alignCenter} style={{ marginTop: '2px', flexFlow: 'nowrap' }}>
                  This is the first step toward AI-powered bid &nbsp;
                  <Tooltip
                    title={"Your awarded loads are saved privately and used only to improve future bid suggestions for your account"}
                    classes={{
                      tooltip: classes.tooltip,
                      arrow: classes.arrow,
                    }}
                    arrow
                    interactive="true"
                  >
                    <span
                      className={`${classes.alignJustifyCenter} ${classes.pointer}`}
                      style={{
                        fontSize: 13, padding: '1px 2px 1px 1px', width: '17px', borderRadius: '20px', backgroundColor: '#fff',
                      }}>🔒</span>
                  </Tooltip>
                </div>
              </div>
            </AnnounceBlock>
          </div>

          <div className={`${classes.alignCenter}`}>
            {totalDrivers ?
              <CardAnalitics
                icon={null}
                component={<div style={{ fontWeight: driversWithZips > 0 ? 900 : 450 }}><span style={{ color: driversWithZips > 0 ? 'green' : '' }}>{driversWithZips}</span><span> / {totalDrivers}</span></div>}
                text={'ZIPs assigned / Drivers total'}
              />
            : null}

            {lastMsgTime ?
              <CardAnalitics
                icon={null}
                //number={`${moment(lastMsgTime).format('HH:mm, MMM DD')}`}
                number={this.timeAgo(lastMsgTime)}
                text={`Last email received`}
              />
            : gmailECMEmailAuthorized ?
              <CardAnalitics
                icon={null}
                number={`No emails received yet`}
              />
            : null}

            {gmailECMEmail && gmailECMEmailAuthorized ?
              <CardAnalitics
                icon={<img
                  alt="Gmail"
                  src="/images/gmail.svg"
                  style={{ height: '15px' }}
                />}
                number={gmailECMEmail}
                text={'Authorized'}
              />
            : null}

            {true &&
              <CardAnalitics
                icon={
                  <Button
                    className={`${(parsingStarted || gmailECMEmailAuthorized) ? classes.gradientWhiteBtn : classes.gradientOrangeBtn} ${classes.nowrap}`}
                    style={{ fontSize: 12, paddingRight: '8px' }}
                    onClick={() => {
                      this.setState({ openOnboarding: true }, () => {
                        this.props.getUserAiDataUpdate();
                        this.runBackgroundCheckOfIncomingEmails();
                      });
                    }}
                  >{parsingStarted ? 'Configure' : 'Set up'}
                    <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: (parsingStarted || gmailECMEmailAuthorized) ? '#4c4c4c' : '#fff', fontSize: 16 }}/>
                  </Button>
                }
                //number={`Configure loads forwarding from your email or loadboard`}
                text={`Configure emails forwarding from your email provider or loadboard`}
                //text={'Configure a redirect from your work email (where you receive emails with loads and/or loadboard)'}
              />
            }
          </div>
        </div>

        <div className={`${classes.fontColor} ${classes.flexRow}`}>
          {showUserConfirm ?
            <div className={classes.popupContainer} onClick={() => this.props.hideUserConfirmation()}>
              <div className={classes.popup}>
                <h2>Well done!</h2>
                <div className={`${classes.alignCenter} ${classes.mb20} ${classes.mt10}`}>
                  <CheckIcon
                    style={{
                      marginRight: '8px',
                      color: '#2FB82C',
                      width: '16px'
                    }}
                  />
                  <span className={`${classes.descriptionFont}`}>The redirect set up successfully.<br></br>Milkyweb should start processing your loads in a while!
                  <br></br>Make sure your Drivers have updated zips</span>
                </div>

                <Button className={`${classes.actionBtn} ${classes.actionBtnBlack}`}
                  onClick={() => {
                    this.props.hideUserConfirmation();
                    this.setState({ userTestEmailSent: false, allInstructionOpened: false });
                    this.instructionStateToLS(false);
                  }}
                >Go to the dashboard</Button>
              </div>
            </div>
          : null}

          {showConfirmGmailConnected ?
            <div className={classes.popupContainer} onClick={() => this.props.hideUserConfirmation()}>
              <div className={classes.popup}>
                <h2>Gmail connected!</h2>
                <div className={`${classes.alignCenter} ${classes.mb20} ${classes.mt10}`}>
                  <CheckIcon
                    style={{
                      marginRight: '8px',
                      color: '#2FB82C',
                      width: '16px'
                    }}
                  />
                  <span className={`${classes.descriptionFont}`}>
                    Milkyweb should start processing your loads in a while!<br></br>
                    Make sure your Drivers have updated zips
                  </span>
                </div>

                <Button className={`${classes.actionBtn} ${classes.actionBtnBlack}`}
                  onClick={() => {
                    this.props.hideUserConfirmation();
                    removeUrlParameter('gmail_auth_sid');
                    this.setState({ userTestEmailSent: false, showConfirmGmailConnected: false });
                    this.instructionStateToLS(false);
                  }}
                >Go to the dashboard</Button>
              </div>
            </div>
          : null}

          {openOnboarding ?
            <OnboardingDialog
              open={true}
              classes={classes}
              arrowRight={this.arrowRight}
              gmailECMEmail={gmailECMEmail}
              settingsIcon={this.settingsIcon}
              emailToCopy={this.emailToCopy}
              onClose={this.onCloseOnboarding}
              runGmailAuthBtn={runGmailAuthBtn}
              autogeneratedMWEmail={this.emailToCopy}
              revokeGmailRedirect={this.revokeGmailRedirect}
              gmailECMEmailAuthorized={gmailECMEmailAuthorized}
              verificationMessage={convertedVerificationEmail}
              redirectSetupTestForm={this.redirectSetupTestForm}
              verificationEmailCreationTime={verificationEmailCreationTime}
            />
          : null}
          
          {allInstructionOpened ?
          <div></div>
            // <div>
            //   <div style={{ width: '45vw', minWidth: '600px', padding: '0 0vw 20px 30px' }}>
            //     <div className={`${classes.mb30}`}>
            //       <div className={classes.alignCenter}>
            //         <h1 className={`${classes.ml20}`}>Greetings on joining Milkyweb AI! {'\uD83D\uDD25'}</h1>
            //       </div>
            //       <div className={`${classes.descriptionFont}`} style={{ margin: '15px 0 5px 20px' }}>
            //         <span className={classes.alignCenter}>Your Milkyweb email forwarding address: {milkyGeneratedEmail}</span>

            //         <div className={classes.mt30}>
            //           <span>You have two options to redirect your emails to us, from:</span>
            //         </div>
            //         <div className={classes.mt20}>
            //           <div style={{ textWrap: 'nowrap' }}>
            //             <div className={classes.alignCenter}>
            //               <li className={classes.alignCenter} style={{ textWrap: 'nowrap' }}>
            //                 - &nbsp;<b className={classes.linkToBlock}
            //                   onClick={() => this.setState({ loadboardInstructionOpened : !loadboardInstructionOpened })}>Load boards&nbsp;</b>
            //               </li>
            //               <ArrowTooltipComponent title="Load boards usually have no forwarding limitations, so we recommend enabling this option if you use at least one load board. <br></br> For handwritten emails, you can also set up forwarding from your mailbox.">
            //                 <div className={`${classes.alignCenter} ${classes.mr10}`} style={{ marginBottom: '3px' }}>
            //                   <i>&nbsp;(preferable</i>
            //                   <HelpRoundedIcon style={{ fontSize: '15px', color: '#AFAECF', marginLeft: '4px' }}/>
            //                   <i>)</i>
            //                 </div>
            //               </ArrowTooltipComponent>
            //             </div>
            //           </div>
            //         </div>

            //         {loadboardInstructionOpened ?
            //           <div className={classes.mb50} style={{ marginLeft: '20px'}}>
            //             <div className={classes.mb30}>
            //               <div style={{ margin: '10px 0 5px 0' }}>
            //                 <span className={classes.h2Title}>1. Set up a redirect from your loadboard to Milkyweb</span>
            //               </div>
            //               <div className={classes.mt10}>
            //                 <span>- Instruction how to set up a redirect if you use:</span>
            //                 <p style={{ margin: '5px 0 0 20px' }}>
            //                   <li
            //                     className={`${classes.textInfo} ${classes.pointer}`}
            //                     onClick={() => this.onEmailProviderClick('sylectus')}
            //                   ><span className={classes.pointer}>Sylectus</span><OpenInNewRoundedIcon className={classes.iconInfo}/></li>
            //                 </p>
            //               </div>
            //             </div>
            //             <div>
            //               <div style={{ margin: '10px 0 5px 0' }}>
            //                 <span className={classes.h2Title}>2. Loadboard authorization message</span>
            //               </div>
            //               <div id='#sylectus_auth_message' className={classes.mt10}>
            //                 <span>Use the instruction you see below to sign in to Sylectus and finish setting up loads sending process you started in section 1:</span>
            //                 {convertedSylectusAuthEmail ?
            //                   <div className={`${classes.mt10}`}>
            //                   <div className={`${classes.p20}`} style={{ backgroundColor: '#fff', border: '1px dashed #347CFF' }}>
            //                     {sylectusAuthEmailCreationTime ? <span style={{ fontSize: 12 }}>{moment(sylectusAuthEmailCreationTime).format('HH:mm, dddd, MMM DD, YYYY')}</span> : null}
            //                     <div className={`${classes.mt20}`}>
            //                       <div dangerouslySetInnerHTML={{ __html: convertedSylectusAuthEmail }}/>
            //                     </div>
            //                   </div>
            //                 </div>
            //                 :
            //                 <div
            //                   className={`${classes.mt10} ${classes.alignCenter} ${classes.p10} ${classes.descriptionFont}`}
            //                   style={{ backgroundColor: '#fff', border: '1px dashed #AFAECF' }}
            //                 >
            //                   <i>Here will appear a Sylectus sign-on instruction email</i>
            //                 </div>}
            //               </div>
                          
            //             </div>

            //           </div>
            //         : null}
                    
            //         <div className={classes.mt20}>
            //           <li className={classes.alignCenter} style={{ textWrap: 'nowrap' }}>
            //             - &nbsp;<b className={classes.linkToBlock}
            //               onClick={() => this.setState({ redirectInstructionOpened : !redirectInstructionOpened })}>Your mailbox</b>
            //           </li>
            //         </div>

            //         {redirectInstructionOpened ?
            //           <div>
            //             <div style={{ margin: '10px 0 5px 20px' }}>
            //               <span className={classes.h2Title}>1. Set up a redirect from your email provider to Milkyweb</span>
            //             </div>
            //             <div style={{ margin: '10px 20px' }} className={`${classes.descriptionFont}`}>
            //               <span> Set up a redirect from your work email (where you receive emails with loads)</span>
            //               <span className={classes.alignCenter}>to the Milkyweb forwarding address:&nbsp;{milkyGeneratedEmail}</span>
            //               {/* <span>(It's our auto-generated email, completely safe and secure, and will be used only as an intermediary between your inbox with loads and the Milkyweb matching system.) </span> */}
            //             </div>
            //           <p className={`${classes.descriptionFont}`} style={{ margin: '5px 0 0 20px' }}>
            //             <span>- Instruction how to set up a redirect if you use:</span>
            //           </p>

            //           <p className={`${classes.descriptionFont}`} style={{ margin: '5px 0 0 40px' }}>
            //             <li
            //               className={`${classes.textInfo} ${classes.pointer}`}
            //               onClick={() => this.onEmailProviderClick('gmail')}
            //             ><span className={classes.pointer}>Gmail</span><OpenInNewRoundedIcon className={classes.iconInfo}/></li>
            //             <li
            //               className={`${classes.textInfo} ${classes.pointer}`}
            //               onClick={() => this.onEmailProviderClick('yahoo')}
            //             ><span className={classes.pointer}>Yahoo</span><OpenInNewRoundedIcon className={classes.iconInfo}/></li>
            //             <li
            //               className={`${classes.textInfo} ${classes.pointer}`}
            //               onClick={() => this.onEmailProviderClick('outlook')}
            //             ><span className={classes.pointer}>Outlook</span><OpenInNewRoundedIcon className={classes.iconInfo}/></li>
            //             <li
            //               className={`${classes.textInfo} ${classes.pointer}`}
            //               onClick={() => this.onEmailProviderClick('microsoft365')}
            //             ><span className={classes.pointer}>Microsoft 365</span><OpenInNewRoundedIcon className={classes.iconInfo}/></li>
            //           </p>

            //           <div className={`${classes.p20} ${classes.m20}`} style={{ border: '1px dashed #DBD9E7', backgroundColor: '#F1F1F6' }}>
            //             <span>
            //             ⚠️ Be aware that Gmail has a daily <a href="https://support.google.com/a/answer/166852?hl=en" target="_blank" rel="noreferrer">forwarding limit</a> of 10,000 emails. Once this limit is reached, emails will stop forwarding. <br></br>
            //               Therefore, we recommend sending emails from load boards directly to Milkyweb and using&nbsp;
            //                 <span
            //                   className={`${classes.textInfo} ${classes.pointer}`}
            //                   onClick={() => this.onEmailProviderClick('gmail_filter')}
            //                 >
            //                   filter
            //                   <OpenInNewRoundedIcon className={classes.iconInfo}/>
            //                 </span>
                            
            //                 &nbsp;to forward other emails from your mailbox.
            //             </span>
            //           </div>


            //           <div style={{ margin: '30px 0 20px 20px' }}>
            //           <span className={classes.h2Title}>2. Redirect verification</span>
            //             <div className={`${classes.descriptionFont} ${classes.mt10}`}>
            //               <span>
            //                 <strong>- For Gmail or Yahoo users: </strong>
            //                 After setting up the redirect, a verification email from your provider will appear below. It's essential to follow the instructions in this email to complete the setup.
            //                 <br></br>
            //                 <strong>- For Other Providers:</strong>
            //                 <span> If you use Outlook, Microsoft 365, or another provider that doesn't require verification, proceed to step 3.</span>
            //               </span>
            //             </div>
            //             {convertedVerificationEmail ?
            //               <div className={`${classes.mt10}`}>
            //                 <div className={`${classes.descriptionFont}`} style={{ marginBottom: '5px' }}>
            //                   <span>Your verification email. Use it to continue setting up emails forwarding process:</span>
            //                 </div>
            //                 <div className={`${classes.p20}`} style={{ backgroundColor: '#fff', border: '1px dashed #347CFF' }}>
            //                   {verificationEmailCreationTime ? <span style={{ fontSize: 12 }}>{moment(verificationEmailCreationTime).format('HH:mm, dddd, MMM DD, YYYY')}</span> : null}
            //                   <div className={`${classes.mt20}`}>
            //                     <div dangerouslySetInnerHTML={{ __html: convertedVerificationEmail }}/>
            //                   </div>
            //                 </div>
            //               </div>
            //               : 
            //               <div
            //                 className={`${classes.mt10} ${classes.alignCenter} ${classes.p10} ${classes.descriptionFont}`}
            //                 style={{ backgroundColor: '#fff', border: '1px dashed #AFAECF' }}
            //               >
            //                 <i>Here will appear a verification message</i>
            //               </div>
            //             }
            //           </div>

            //           <div style={{ margin: '30px 0 5px 20px' }}>
            //             <h2 style={{ marginBottom: '5px' }}>3. Check redirect</h2>
            //             <div className={`${classes.descriptionFont}`}>
            //               <span>As soon as Milkyweb receives your first redirected email, we'll begin processing your emails.</span><br></br>
            //               <br></br>
            //               <span><strong>- Test Your Setup:</strong> To confirm the redirection is active, you can perform a simple verification test.</span>
            //             </div>
            //           </div>

            //           {this.redirectSetupTestForm}
            //         </div>
            //         : null}
            //       </div>
            //     </div>

            //     <div className={`${classes.descriptionFont} ${classes.p20} ${classes.mt20}`}>
            //       <span> <strong>Need help?</strong> Contact our support team via chat at the right bottom of the page or email <i>support@milkyweb.net</i></span>
            //     </div>
            //   </div>
            // </div>
          : null}
        </div>
      </div>
    )
  }
};

export default withStyles(styles)(DashboardAiPage);
